<template>
  <v-content>
    <div class="v2-root">
      <v-container grid-list-md class="pa-3">
        <v-layout justify-center>
          <v-flex xs12 sm8 md5>
            <v-card flat class="v2-card text-xs-center pa-4">
              <v-avatar size="48" color="primary" class="mb-3"><v-icon dark>account_balance</v-icon></v-avatar>
              <div class="v2-section-title mb-3">Connect your bank</div>
              <plaid-link
                env="production"
                publicKey="886db1962c11b1d9252fd8be9b593e"
                clientName="Lendwizely"
                :product="['auth', 'transactions']"
                :token="params.token"
                v-bind="{ onSuccess, onLoad }"
                class="btnOpenPlaid v-btn v-btn--depressed theme--dark primary"
                :style="{ display: isPlaidReady ? 'inline-flex' : 'none' }"
              >
                Open Link and connect your bank!
              </plaid-link>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-content>
</template>

<script>
import PlaidLink from 'vue-plaid-link'
import queryString from 'query-string'
import axios from 'axios'
import { URL } from '../../../env'
import v2Theme from '../mixins/v2Theme'
import '../styles/v2.css'

export default {
  mixins: [v2Theme],
  components: { PlaidLink },
  data: () => ({
    isPlaidReady: false,
    params: queryString.parse(window.location.search),
  }),
  methods: {
    onSuccess(token) {
      axios.post(`${URL}/receive_accounting/public_token`, {
        public_token: token,
        company_plaid_id: queryString.parse(window.location.search).id,
      })
    },
    onLoad() {
      this.isPlaidReady = true
      document.getElementsByClassName('btnOpenPlaid')[0].click()
    },
  },
}
</script>
